import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  
*/
{
  "id": "e+na5ccC",
  "block": "[[],[],false,[]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/@ember/legacy-built-in-components.4938bbb1/node_modules/@ember/legacy-built-in-components/templates/empty.hbs",
  "isStrictMode": false
});